// generated by scripts/emit_composition_layout.py, do not edit
// Source of truth: apps/backend/services/composition/layout.py
// Regenerate with `make generate-types`; CI fails on drift.

export const COMPOSITION_LAYOUT = {
  "blocks": {
    "agent_deep_dive": {
      "category": "intelligence",
      "default": {
        "h": 12,
        "w": 12
      },
      "min": {
        "h": 12,
        "w": 6
      },
      "new_item_name": "Agent deep dive",
      "offered": true,
      "stored_chart_type": "agent_deep_dive",
      "surfaces": [
        "report"
      ]
    },
    "analysis": {
      "category": "intelligence",
      "default": {
        "h": 6,
        "w": 12
      },
      "min": {
        "h": 2,
        "w": 2
      },
      "new_item_name": "Analysis",
      "offered": true,
      "stored_chart_type": "analysis",
      "surfaces": [
        "report"
      ]
    },
    "anchors": {
      "category": "visual",
      "default": {
        "h": 2,
        "w": 12
      },
      "min": {
        "h": 1,
        "w": 6
      },
      "new_item_name": "Anchors",
      "offered": false,
      "stored_chart_type": "anchors",
      "surfaces": [
        "report"
      ]
    },
    "attribution_table": {
      "category": "visual",
      "default": {
        "h": 8,
        "w": 12
      },
      "min": {
        "h": 5,
        "w": 6
      },
      "new_item_name": "Attribution rules",
      "offered": false,
      "stored_chart_type": "attribution_table",
      "surfaces": [
        "report"
      ]
    },
    "bridge": {
      "category": "visual",
      "default": {
        "h": 8,
        "w": 12
      },
      "min": {
        "h": 6,
        "w": 6
      },
      "new_item_name": "Revenue bridge",
      "offered": false,
      "stored_chart_type": "revenue_bridge",
      "surfaces": [
        "report"
      ]
    },
    "chart": {
      "category": "visual",
      "default": {
        "h": 8,
        "w": 6
      },
      "min": {
        "h": 6,
        "w": 3
      },
      "new_item_name": "New chart",
      "offered": true,
      "surfaces": [
        "dashboard",
        "report"
      ]
    },
    "cohort_returns": {
      "category": "visual",
      "default": {
        "h": 8,
        "w": 12
      },
      "min": {
        "h": 6,
        "w": 6
      },
      "new_item_name": "Returns by order week",
      "offered": false,
      "stored_chart_type": "cohort_returns",
      "surfaces": [
        "report"
      ]
    },
    "control": {
      "category": "visual",
      "default": {
        "h": 2,
        "w": 3
      },
      "min": {
        "h": 2,
        "w": 2
      },
      "new_item_name": "Control",
      "offered": true,
      "surfaces": [
        "dashboard",
        "report"
      ]
    },
    "follow_up": {
      "category": "visual",
      "default": {
        "h": 4,
        "w": 12
      },
      "min": {
        "h": 2,
        "w": 6
      },
      "new_item_name": "Last period's actions",
      "offered": false,
      "stored_chart_type": "follow_up",
      "surfaces": [
        "report"
      ]
    },
    "heading": {
      "category": "visual",
      "default": {
        "h": 2,
        "w": 12
      },
      "min": {
        "h": 1,
        "w": 2
      },
      "new_item_name": "Heading",
      "offered": true,
      "surfaces": [
        "dashboard",
        "report"
      ]
    },
    "kpi": {
      "category": "visual",
      "default": {
        "h": 4,
        "w": 3
      },
      "min": {
        "h": 3,
        "w": 2
      },
      "new_item_name": "New KPI",
      "offered": true,
      "surfaces": [
        "dashboard",
        "report"
      ]
    },
    "shape": {
      "category": "visual",
      "default": {
        "h": 1,
        "w": 12
      },
      "min": {
        "h": 1,
        "w": 1
      },
      "new_item_name": "Line",
      "offered": true,
      "surfaces": [
        "dashboard",
        "report"
      ]
    },
    "smart_text": {
      "category": "visual",
      "default": {
        "h": 4,
        "w": 6
      },
      "min": {
        "h": 2,
        "w": 2
      },
      "new_item_name": "Smart text",
      "offered": true,
      "surfaces": [
        "dashboard",
        "report"
      ]
    },
    "table": {
      "category": "visual",
      "default": {
        "h": 8,
        "w": 6
      },
      "min": {
        "h": 5,
        "w": 3
      },
      "new_item_name": "New table",
      "offered": true,
      "surfaces": [
        "dashboard",
        "report"
      ]
    },
    "text": {
      "category": "visual",
      "default": {
        "h": 4,
        "w": 6
      },
      "min": {
        "h": 2,
        "w": 2
      },
      "new_item_name": "Text",
      "offered": true,
      "surfaces": [
        "dashboard",
        "report"
      ]
    }
  },
  "chart_chrome_px": 58,
  "columns": 12,
  "drawing": {
    "backdrop": {
      "arrow_directions": [
        "right",
        "left",
        "up",
        "down"
      ],
      "arrow_px": [
        1,
        2,
        3,
        4
      ],
      "arrow_styles": [
        "line",
        "block"
      ],
      "callout_max_chars": 280,
      "callout_tails": [
        "bottom_left",
        "bottom_right",
        "top_left",
        "top_right",
        "left",
        "right",
        "none"
      ],
      "callout_text_sizes": [
        "sm",
        "md",
        "lg"
      ],
      "corner_radius_max_px": 48,
      "default_sizes": {
        "arrow": {
          "h": 2,
          "w": 2
        },
        "callout": {
          "h": 4,
          "w": 3
        },
        "figure": {
          "h": 8,
          "w": 4
        }
      },
      "figures": [
        "rectangle",
        "circle",
        "triangle",
        "heart",
        "diamond",
        "pentagon",
        "star",
        "hexagon",
        "octagon",
        "cylinder"
      ],
      "fills": [
        "none",
        "subtle",
        "primary_subtle",
        "primary",
        "surface"
      ],
      "kinds": [
        "figure",
        "arrow",
        "callout"
      ],
      "max_shapes": 50,
      "outline_px": [
        0,
        1,
        2,
        3,
        4
      ],
      "stretching_figures": [
        "rectangle"
      ],
      "stroke_styles": [
        "solid",
        "dashed",
        "dotted"
      ]
    },
    "border_sides": [
      "top",
      "right",
      "bottom",
      "left"
    ],
    "border_thicknesses_px": [
      1,
      2,
      3,
      4
    ],
    "card_surfaces": [
      "card",
      "none"
    ],
    "colors": [
      "rule",
      "muted",
      "text",
      "primary"
    ],
    "custom_color_pattern": "^#[0-9a-f]{6}$",
    "line_orientations": [
      "horizontal",
      "vertical"
    ],
    "line_thicknesses_px": [
      1,
      2,
      3,
      4,
      6,
      8
    ],
    "palette_slots": [
      "palette_1",
      "palette_2",
      "palette_3",
      "palette_4",
      "palette_5",
      "palette_6",
      "palette_7",
      "palette_8"
    ],
    "shape_kinds": [
      "line"
    ]
  },
  "eyebrow_char_px": 11,
  "gap_px": 12,
  "min_chart_canvas_px": 80,
  "page_density": {
    "band_pad_x_px": 16,
    "band_pad_y_px": 12,
    "bullets_gap_px": 10,
    "caption_line_px": 16,
    "eyebrow_gap_px": 8,
    "eyebrow_line_px": 16,
    "frame_border_px": 1,
    "frame_gap_px": 8,
    "frame_pad_px": 16,
    "frame_title_px": 18,
    "kpi_narrow_below_px": 220,
    "kpi_note_line_px": 20,
    "kpi_note_lines": 2,
    "kpi_pad_narrow_px": 12,
    "kpi_pad_px": 16,
    "kpi_row_gap_px": 3,
    "kpi_row_line_px": 18,
    "kpi_rows_gap_px": 2,
    "kpi_strip_pad_y_px": 10,
    "kpi_title_font_narrow_px": 12,
    "kpi_title_font_px": 13,
    "kpi_title_gap_px": 8,
    "kpi_title_line_narrow_px": 15,
    "kpi_title_line_px": 16,
    "kpi_title_lines": 2,
    "kpi_value_font_narrow_px": 24,
    "kpi_value_line_px": 30,
    "list_body_line_px": 20,
    "list_heading_gap_px": 8,
    "list_heading_px": 16,
    "list_item_pad_y_px": 10,
    "list_max_body_lines": 2,
    "list_rule_px": 1,
    "list_title_body_gap_px": 4,
    "list_title_line_px": 18,
    "prose_font_px": 14,
    "prose_line_px": 21,
    "subtitle_font_px": 12,
    "subtitle_line_px": 16,
    "subtitle_lines": 2,
    "table_cell_line_px": 17,
    "table_cell_pad_x_px": 10,
    "table_cell_pad_y_px": 6,
    "table_font_px": 12,
    "table_header_font_px": 11,
    "table_header_line_px": 15,
    "table_header_row_px": 28,
    "table_max_columns": {
      "landscape": 10,
      "portrait": 7
    },
    "table_row_2line_px": 47,
    "table_row_px": 30,
    "table_rule_px": 1,
    "thesis_font_px": 22,
    "thesis_gap_px": 10,
    "thesis_line_px": 28,
    "thesis_max_lines": 2
  },
  "page_formats": {
    "landscape": {
      "content_height_px": 698,
      "content_width_px": 1027,
      "furniture": {
        "cover": true,
        "footer": true,
        "header": true,
        "page_number": true
      },
      "grid_height_px": 674,
      "label": "A4 landscape",
      "margin_px": 48,
      "orientation": "landscape",
      "page_height_px": 794,
      "page_width_px": 1123,
      "paper": "A4",
      "rows": 16,
      "top_lead_in_px": 24
    },
    "portrait": {
      "content_height_px": 1027,
      "content_width_px": 698,
      "furniture": {
        "cover": true,
        "footer": true,
        "header": true,
        "page_number": true
      },
      "grid_height_px": 1003,
      "label": "A4 portrait",
      "margin_px": 48,
      "orientation": "portrait",
      "page_height_px": 1123,
      "page_width_px": 794,
      "paper": "A4",
      "rows": 24,
      "top_lead_in_px": 24
    }
  },
  "row_height_px": 30,
  "rows": [
    {
      "counts": [
        2,
        3,
        4,
        6
      ],
      "default_count": 4,
      "description": "A full row of KPI cards, one number each.",
      "height": 4,
      "key": "kpi_row",
      "label": "KPI row",
      "slots_by_count": {
        "2": [
          {
            "block_type": "kpi",
            "w": 6
          },
          {
            "block_type": "kpi",
            "w": 6
          }
        ],
        "3": [
          {
            "block_type": "kpi",
            "w": 4
          },
          {
            "block_type": "kpi",
            "w": 4
          },
          {
            "block_type": "kpi",
            "w": 4
          }
        ],
        "4": [
          {
            "block_type": "kpi",
            "w": 3
          },
          {
            "block_type": "kpi",
            "w": 3
          },
          {
            "block_type": "kpi",
            "w": 3
          },
          {
            "block_type": "kpi",
            "w": 3
          }
        ],
        "6": [
          {
            "block_type": "kpi",
            "w": 2
          },
          {
            "block_type": "kpi",
            "w": 2
          },
          {
            "block_type": "kpi",
            "w": 2
          },
          {
            "block_type": "kpi",
            "w": 2
          },
          {
            "block_type": "kpi",
            "w": 2
          },
          {
            "block_type": "kpi",
            "w": 2
          }
        ]
      },
      "surfaces": [
        "dashboard",
        "report"
      ]
    },
    {
      "counts": [
        2,
        3,
        4
      ],
      "default_count": 2,
      "description": "Two, three or four charts side by side.",
      "height": 8,
      "key": "chart_row",
      "label": "Chart row",
      "slots_by_count": {
        "2": [
          {
            "block_type": "chart",
            "w": 6
          },
          {
            "block_type": "chart",
            "w": 6
          }
        ],
        "3": [
          {
            "block_type": "chart",
            "w": 4
          },
          {
            "block_type": "chart",
            "w": 4
          },
          {
            "block_type": "chart",
            "w": 4
          }
        ],
        "4": [
          {
            "block_type": "chart",
            "w": 3
          },
          {
            "block_type": "chart",
            "w": 3
          },
          {
            "block_type": "chart",
            "w": 3
          },
          {
            "block_type": "chart",
            "w": 3
          }
        ]
      },
      "surfaces": [
        "dashboard"
      ]
    },
    {
      "counts": [],
      "default_count": null,
      "description": "A wide chart with a table next to it.",
      "height": 8,
      "key": "chart_table_row",
      "label": "Chart and table",
      "slots_by_count": {
        "fixed": [
          {
            "block_type": "chart",
            "w": 8
          },
          {
            "block_type": "table",
            "w": 4
          }
        ]
      },
      "surfaces": [
        "dashboard"
      ]
    },
    {
      "counts": [],
      "default_count": null,
      "description": "One chart across the width of the page.",
      "height": 8,
      "key": "chart_full",
      "label": "Full-width chart",
      "slots_by_count": {
        "fixed": [
          {
            "block_type": "chart",
            "w": 12
          }
        ]
      },
      "surfaces": [
        "report"
      ]
    },
    {
      "counts": [],
      "default_count": null,
      "description": "Two charts of the same period, half the page each.",
      "height": 8,
      "key": "chart_pair",
      "label": "Two charts side by side",
      "slots_by_count": {
        "fixed": [
          {
            "block_type": "chart",
            "w": 6
          },
          {
            "block_type": "chart",
            "w": 6
          }
        ]
      },
      "surfaces": [
        "report"
      ]
    },
    {
      "counts": [],
      "default_count": null,
      "description": "One table across the page, as tall as the rows it shows.",
      "height": 8,
      "key": "table_full",
      "label": "Full-width table",
      "slots_by_count": {
        "fixed": [
          {
            "block_type": "table",
            "w": 12
          }
        ]
      },
      "surfaces": [
        "report"
      ]
    },
    {
      "counts": [],
      "default_count": null,
      "description": "The page's one big finding: a short reading and the chart it reads, with a list of smaller findings next to them.",
      "height": 10,
      "key": "feature_row",
      "label": "A reading over its chart, with a list beside them",
      "slots_by_count": {
        "fixed": [
          {
            "block_type": "analysis",
            "h": 4,
            "w": 6,
            "x": 0,
            "y": 0
          },
          {
            "block_type": "chart",
            "h": 6,
            "w": 6,
            "x": 0,
            "y": 4
          },
          {
            "block_type": "analysis",
            "h": 10,
            "w": 6,
            "x": 6,
            "y": 0
          }
        ]
      },
      "surfaces": [
        "report"
      ]
    },
    {
      "counts": [],
      "default_count": null,
      "description": "One written reading of the blocks it names.",
      "height": 6,
      "key": "analysis_full",
      "label": "Written analysis",
      "slots_by_count": {
        "fixed": [
          {
            "block_type": "analysis",
            "w": 12
          }
        ]
      },
      "surfaces": [
        "report"
      ]
    }
  ],
  "sections": [
    {
      "data_blocks": 3,
      "description": "A heading, a row of headline numbers, and a paragraph that reads them.",
      "height": 10,
      "key": "overview",
      "label": "Overview",
      "slots": [
        {
          "blocks": [
            {
              "block_type": "kpi",
              "w": 4
            },
            {
              "block_type": "kpi",
              "w": 4
            },
            {
              "block_type": "kpi",
              "w": 4
            }
          ],
          "height": 4,
          "kind": "row",
          "template": "kpi_row"
        },
        {
          "analysis_kind": "narrative",
          "blocks": [
            {
              "block_type": "analysis",
              "w": 12
            }
          ],
          "height": 4,
          "items": null,
          "kind": "analysis",
          "title": "In short"
        }
      ]
    },
    {
      "data_blocks": 1,
      "description": "A heading, one chart across the page, and the takeaways from it.",
      "height": 17,
      "key": "trend",
      "label": "Trend",
      "slots": [
        {
          "blocks": [
            {
              "block_type": "chart",
              "w": 12
            }
          ],
          "height": 8,
          "kind": "row",
          "template": "chart_full"
        },
        {
          "analysis_kind": "key_takeaways",
          "blocks": [
            {
              "block_type": "analysis",
              "w": 12
            }
          ],
          "height": 7,
          "items": 3,
          "kind": "analysis",
          "title": "What the trend says"
        }
      ]
    },
    {
      "data_blocks": 1,
      "description": "A heading, a full-width table of ten rows, and the takeaways from it.",
      "height": 20,
      "key": "breakdown",
      "label": "Breakdown",
      "slots": [
        {
          "blocks": [
            {
              "block_type": "table",
              "w": 12
            }
          ],
          "height": 11,
          "kind": "row",
          "template": "table_full"
        },
        {
          "analysis_kind": "key_takeaways",
          "blocks": [
            {
              "block_type": "analysis",
              "w": 12
            }
          ],
          "height": 7,
          "items": 3,
          "kind": "analysis",
          "title": "What the breakdown says"
        }
      ]
    },
    {
      "data_blocks": 1,
      "description": "A heading and one long table, for the appendix of a report.",
      "height": 16,
      "key": "detail",
      "label": "Detail",
      "slots": [
        {
          "blocks": [
            {
              "block_type": "table",
              "w": 12
            }
          ],
          "height": 14,
          "kind": "row",
          "template": "table_full"
        }
      ]
    },
    {
      "data_blocks": 0,
      "description": "A heading and a numbered list of what to do next.",
      "height": 9,
      "key": "actions",
      "label": "Actions",
      "slots": [
        {
          "analysis_kind": "recommendations",
          "blocks": [
            {
              "block_type": "analysis",
              "w": 12
            }
          ],
          "height": 7,
          "items": 3,
          "kind": "analysis",
          "title": "What to do next"
        }
      ]
    }
  ],
  "vertical_line": {
    "h": 4,
    "w": 1
  },
  "visualizations": {
    "funnel_explorer": {
      "default": {
        "h": 20,
        "w": 12
      },
      "min": {
        "h": 18,
        "w": 6
      }
    }
  }
} as const;
